module.exports = __webpack_public_path__ + "img/bg.3f538152.png";